/**
 * BOTTOM GENERAL INITS
 * HEADER INITS
 */

/**
 * ---------------------------------------------------------------
 * STATIC CONSTRUCTS
 * Selectors lookups
 * ---------------------------------------------------------------
 */

app.objMap = Object.assign(app.objMap, {
  header: '#header'
});


/**
 * ---------------------------------------------------------------
 * Self Init Stuff Map (procedural)
 * ---------------------------------------------------------------
 * [app.inits]||[init](initMap, [ {NS: ["nsp", "aux"]} ]);
 */

// INITS HEADERS
app.inits.headers = (function(init) {
  var initMap = function(arg) {

    // INIT HEADER
    if (app.$jObjMap["header"].length) {
      app.header.init(app.$jObjMap["header"]);
    }
    
  };

  // IIFE init
  init(initMap);

  // return a callable fn
  return function() {
    init(initMap);
  };
  
}(app.inits));

/**
 * ---------------------------------------------------------------
 * bottom straight Init Stuff
 * ---------------------------------------------------------------
 */

// ...


/* EOF */